import {animationFrameScheduler, interval} from 'rxjs';
import {share} from 'rxjs/operators';

export const UPDATES_GATING_PERIOD = 250;

/**
 * Used for updates buffering synchronization between widgets
 */
export const WIDGET_UPDATES_GATING$ = interval(UPDATES_GATING_PERIOD, animationFrameScheduler)
    .pipe(share());
